import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import Empty from 'constants/empty';
import { hasAutoReplenishmentSubscriptionsSelector } from 'viewModel/selectors/user/hasAutoReplenishmentSubscriptionsSelector';

/**
 * Custom hook for Auto Replenishment Page Content component.
 * Determines whether to render the empty hub or regular auto replenishment content
 * based on feature flags and user subscription status.
 *
 * @returns {Object} Hook state
 * @returns {boolean} returns.shouldRenderEmptyHub - True if empty hub should be displayed
 */
const useAutoReplenishmentPageContent = () => {
    const hasAutoReplenishmentSubscriptions = useSelector(hasAutoReplenishmentSubscriptionsSelector);

    const featureFlags = useMemo(() => {
        const config = (typeof Sephora !== 'undefined' && Sephora.configurationSettings) || Empty.Object;

        return {
            isAutoReplenishEmptyHubEnabled: config.isAutoReplenishEmptyHubEnabled
        };
    }, []);

    const shouldRenderEmptyHub = featureFlags.isAutoReplenishEmptyHubEnabled && !hasAutoReplenishmentSubscriptions;

    return {
        shouldRenderEmptyHub
    };
};

export default useAutoReplenishmentPageContent;
